<script lang="ts" setup>
import { useRoute } from "#app";

// Properties
const props = defineProps({
    tabs: {
        type: Object,
        default: {},
    },
    initialActiveTab: {
        type: String,
        default: "",
    },
    width: {
        type: String,
        default: "w-1/2 md:w-1/3 lg:w-1/5 last:w-full md:last:w-1/3 lg:last:w-1/5",
    },
});

// Data
const activeTab = ref("");
const route = useRoute();

// Functions
function clickTab(val: string) {
    activeTab.value = val;
    history.pushState({}, "", route.path + "#" + val);

    const offset = 200;
    const ele = document.querySelector("#" + val);
    if (val && ele) {
        window.scrollTo({
            behavior: "smooth",
            top: ele.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
        });
    }
}

onMounted(() => {
    if (props.initialActiveTab) {
        activeTab.value = props.initialActiveTab;
    } else if (window.location.hash) {
        activeTab.value = window.location.hash.substr(1);
    } else {
        activeTab.value = Object.keys(props.tabs)[0];
    }
});
</script>

<template>
    <div>
        <div class="sticky top-[125px] z-30 border-b-4 bg-white">
            <ul class="-mb-1 list-none overflow-auto">
                <li
                    v-for="(val, key) in tabs"
                    :key="'li-' + key"
                    class="hover:border-primary float-left cursor-pointer border-b-4 px-8 py-3 text-center whitespace-nowrap hover:font-bold"
                    :class="width + ' ' + (activeTab === key ? 'border-primary font-bold' : '')"
                    @click="clickTab(key)"
                >
                    {{ val }}
                </li>
            </ul>
        </div>
        <div v-for="(val, key) in tabs" :id="key" :key="key">
            <slot :name="key"></slot>
        </div>
    </div>
</template>
